import { createContext } from "react";
import { AxiosInstance } from "axios";

export type ApiClientContextValue = {
  client: AxiosInstance;
};

export const ApiClientContext = createContext<ApiClientContextValue | undefined>(undefined);
